import { css, Theme } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const edit = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const editIcon = css`
  cursor: pointer;
`

export const longText = css`
  max-height: 60px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const modalContainerWrapper = css`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const modalContainer = (theme: Theme) => css`
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 24px;
  padding: 16px;
  width: 900px;
  max-width: calc(100% - 40px);
  box-sizing: border-box;
  max-height: 95vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const columns = (count: number) => (theme: Theme) =>
  css`
    display: grid;
    grid-template-columns: repeat(${count}, 1fr);
    gap: 16px;

    ${theme.breakpoints.down(700)} {
      grid-template-columns: 1fr;
    }
  `

export const modalForm = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const modalTitle = css`
  font-weight: 700;
  text-align: center;
`

export const label = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  text-align: start;
`

export const deletingError = (theme: Theme) => css`
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 16px;
  background: ${getColorOptions(theme.colors.red).soft};
`

export const deletingErrorText = (theme: Theme) => css`
  color: ${theme.colors.red};
`

export const deletingErrorLink = (theme: Theme) => css`
  color: ${theme.colors.red};
`

export const select = css`
  .MuiSelect-select {
    padding-right: 20px !important;
    text-align: start;
  }
`

export const descriptionInput = css`
  box-sizing: border-box;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 70px;
`

export const buttons = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
`

export const button = css`
  width: 200px;
`

export const fullButton = css`
  width: 417px;
`
